module.exports = __webpack_public_path__ + "static/img/bigfail.1c706a97.png";